var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile__header"},[_c('img',{attrs:{"src":require("@/assets/icons/profile/arrow-back.svg"),"alt":"back"}}),_c('p',{staticClass:"profile__subtitle profile__subtitle_tin"},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/icons/profile/Close-icon.svg"),"alt":"close"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }